export function lookbookSlider() {
    function masonryGrid() {
        var $grid = $('.lookbook-grid').masonry({
            itemSelector: '.lookbook-item',
            columnWidth: '.lookbook-item',
        });
        $grid.imagesLoaded().progress(function () {
            $grid.masonry();
        });
    }

    masonryGrid();

    let lookbookList = $('.lookbook-list');
    if (lookbookList.length) {
        lookbookList.on('click', '.wp-pagenavi a', function (e) {
            e.preventDefault();

            let _this = $(this);
            let ajax_url = ajax_params.ajaxurl;
            let data = {
                'action': 'paginationLookbook',
                'perpage': lookbookList.attr('data-per-page'),
                'paged': _this.data('paged')
            };

            $.ajax({
                type: "POST",
                url: ajax_url,
                data: data,
                success: function (response) {
                    if (response) {
                        let $holder = $('.holder-ajax-container');
                        let content = $(response);
                        content.css({'opacity': 0});
                        $holder.html(content);
                        content.animate({'opacity': 1}, 300);

                        masonryGrid();

                        $("html, body").animate({scrollTop: lookbookList.offset().top - $('.header').innerHeight() * 1.5}, 500);
                    }
                }
            });
        });
    }

    // const slider = $(".lookbook-slider-section .slider");
    // slider.slick({
    //     infinite: true,
    //     fade: true,
    //     prevArrow: $(".common-slider-controls .prev-arrow"),
    //     nextArrow: $(".common-slider-controls .next-arrow"),
    // }).on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    //     if ($(".slick-current").find("iframe").length) {
    //         const player = $(".slick-current").find("iframe");
    //         const source = player.attr("src");
    //         player.attr("src", "");
    //         player.attr("src", source);
    //     }
    // });
}


// WEBPACK FOOTER //
// ./assets/js/modules/lookbook-slider.js